import enums from '@/helpers/enums';

const state = {
  username: '',
  roles: [],
  avatarUrl: '',
  userInfoId: 0
};

const getters = {
  authorized(state) {
    return state.username !== '';
  },
  is_content_admin(state) {
    return (
      state.roles.includes(enums.ROLES.CONTENT_ADMIN) || state.roles.includes(enums.ROLES.ADMIN)
    );
  },
  is_admin(state) {
    return state.roles.includes(enums.ROLES.ADMIN);
  },
  avatarUrl(state) {
    return state.avatarUrl;
  },
  userInfoId(state) {
    return state.userInfoId;
  }
};

const actions = {
  authorize({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get('auth/authorize')
        .then((response) => {
          commit('SET_IDENTITY', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
};

const mutations = {
  SET_IDENTITY(state, payload) {
    state.username = payload.username;
    state.roles = payload.roles;
    state.avatarUrl = payload.avatarUrl;
    state.userInfoId = payload.userInfoId;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
